<template>
  <div id="app">
    <component :is="addHeader" :routerName="currentRouterName"></component>
    <component :is="addlayout"></component>
  </div>
</template>
<script>
import Header from "@/components/header/header"
import startBlockLayout from "@/layouts/startBlockLayout"
import bgWhiteLayout from "@/layouts/bgWhiteLayout"
import mainLayout from "@/layouts/mainLayout"

export default {
  data: () => ({
    currentRouterName: '' //Название текущего роута(для включения/отключения кнопок в header)
  }),
  computed: {
    //показать/скрыть Header на страницах
    addHeader(){
      return this.$route.meta.header
    },
    addlayout(){
      return this.$route.meta.layout
    }
  },
  components: {
    Header, startBlockLayout, bgWhiteLayout, mainLayout
  },
  watch: {
    '$route'(){
      this.currentRouterName = this.$router.currentRoute.name
    }
  }
}
</script>

<style lang="scss">
  @import "~bootstrap/dist/css/bootstrap-grid.min.css";
  @import "~bootstrap/dist/css/bootstrap-reboot.min.css";
  @import "~bootstrap/dist/css/bootstrap.min.css";
  @import '~bootstrap-vue/dist/bootstrap-vue.css';
  @import "~slick-slider/slick/slick.css";
  @import "assets/main.css";
  @import "assets/vueStyles.scss";
</style>
 